import React from "react"
import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal"
import "./modal-expired-points.scss"
import { siteUrl } from "../../../shared/utils/siteUrl"
import { LOCALE } from "../../../constants/country.constants"
const is_argentinizado = ["es-AR", "es-PY"].includes(LOCALE)
const txtRedimir = ["es-AR", "es-PY", "es-CL", "es-PE"].includes(LOCALE)
  ? "canjear"
  : "redimir"
const default_date = "8 de abril"
const expireddate =
  {
    "es-CO": default_date,
    "es-EC": "11 de abril",
    "es-PE": "10 de abril",
    "es-PY": "5 de abril",
    "es-AR": "4 de abril",
    "es-DO": "1 de abril",
    "es-PR": "2 de abril",
    "es-CL": "3 de abril",
  }[LOCALE] || default_date

const getParagraph = () => {
  if (is_argentinizado) {
    return (
      <>
        Entrá ya, porque podés tener varios que se van a vencer.{" "}
        <b>¡No los perdás!</b>
      </>
    )
  }
  return (
    <>
      Entra ya, porque puedes tener varios que se van a vencer.{" "}
      <b>¡No los pierdas!</b>
    </>
  )
}
export default function ModalExpiredPoints({ user, onClose, points = 0 }) {
  const name = user.name

  const handlerClose = () => {
    onClose()
  }
  const handlerCallToAction = () => {
    let url = siteUrl + "/magazin/concursos/master-quiz"
    window.open(url, "_self")
    onClose()
  }

  return (
    <GenericModal background="transparent">
      <div className="f-modal-expired-points">
        <button className="btn-close" onClick={handlerClose}></button>
        <div className="title-wrapper">
          <h3 className="title">Hola {name}, tienes </h3>
          <div className="rombo-points">{points}</div>
        </div>
        <p className="main-paragraph">{getParagraph()}</p>
        <footer>
          <button className="btn-action" onClick={handlerCallToAction}>
            ¡Quiero {txtRedimir}!
          </button>
          <p>Tienes hasta el {expireddate} para hacerlo</p>
        </footer>
      </div>
      +
    </GenericModal>
  )
}
